import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {WalletTab} from './constant'

export interface RedirectInfo {
  redirect_url: string
  redirect_param: {[key: string]: string}
  redirect_method: 'get' | 'post'
}

export interface ProductsItemInterface {
  coins?: number
  bonus_coins?: number
  desc?: string
  dt?: number
  id?: string
  product_id?: string
  name?: string
  out_code?: string
  price?: number
  type?: string
  currency?: string
  chat_tag?: string
}
export interface ThirdPartyListItem {
  pay_method_id: number
  name: string
  img: string
  is_unfold: boolean
  list: Array<{
    product_id: string
    price: number
    coins: number
    currency: string
  }>
}
export interface CoinsAgencyItem {
  mid: number
  name: string
  flag_url: string // 国旗url
  avatar: string
  coins_on_sale: number // 可卖金币
  trade_times: number // 交易次数
  contact: string // 联系方式
  status: number // 0. 非在线 1. 在线
}

export interface ProductsListInterface {
  client_index: number // 客户端商品下标 需要进行优化，client_index为客户端充值渠道在第三方充值中的位置
  huawei_list: ProductsItemInterface[]
  list: ProductsItemInterface[]
  visa_list: ProductsItemInterface[]
  coins: number
  game_coins: number
  agreement_url: string
  tickets: number
  status: number
  exchange_cnt: number
  remain_tm: number
  is_recharged: number
  is_aristocracy: number
  before_recharged: number
  is_ra_customer: boolean
  exchange_tickets_ratio: number
  countries: Array<{
    code: number
    name: string
  }>
  default_country: {
    code: number
    name: string
  }
  third_party_list: ThirdPartyListItem[]
  is_union: number // 是否是公会主播
  recharge_version: 'v1' | 'v2' // 控制新版首充礼包AB文案
  is_first_recharge: boolean
  baseInfo?: {
    mid: number //	用户mid
    show_id: string //	用户展示ID
    avatar_url: string //	头像URL
    name: string // 用户昵称
    region_code: number
  }
  extra_desc_url: string // chat业务充值额外奖励说明页地址
  is_union_anchor: boolean // 是否是主播
  is_audit_ver: boolean // 是否是审核版本，如果是审核版本，需要屏蔽掉页面上的审核敏感内容
  is_recharge_limit: boolean // 谷歌苹果充值金额是否达到限制
  has_salary_wallet: boolean // 是否展示薪资钱包
}
const initialState: {
  coinsAgency: CoinsAgencyItem[] // 币商列表
  curTab: number // 当前所在tab
  wallet: ProductsListInterface
  walletDiamond: {
    overage: number // 余额（美元）
    total_diamond: number // 总钻石
    room_diamond: number // 直播间内钻石（可兑换的钻石）
    out_diamond: number // 直播间外钻石
    product_list: Array<{id: number; money: number; diamond: number}> // 产品列表
    is_exchange: boolean // 是否可以兑换
    current_level: number // 当前等级
    current_level_salary: number // 当前等级最高兑换薪资
    exchanged_salary: number // 已兑换薪资
    enable_exchange_salary: number // 可兑换薪资
    official_reward_coin: number // 官方奖励金币
    official_reward_salary: number // 官方奖励薪资
    official_reward_is_open: boolean // 官方奖励是否开启
  }
} = {
  coinsAgency: [],
  curTab: WalletTab.金币,
  wallet: {
    client_index: 0,
    huawei_list: [],
    list: [],
    visa_list: [],
    coins: 0,
    game_coins: 0,
    agreement_url: '',
    tickets: 0,
    status: 0,
    exchange_cnt: 0,
    remain_tm: 0,
    is_recharged: 0,
    is_aristocracy: 0,
    before_recharged: 0,
    is_ra_customer: false,
    exchange_tickets_ratio: 0,
    countries: [],
    default_country: {
      code: 0,
      name: '',
    },
    third_party_list: [],
    is_union: 0, // 是否是公会主播
    recharge_version: 'v1', // 控制新版首充礼包AB文案
    is_first_recharge: false,
    extra_desc_url: '',
    is_audit_ver: true,
    is_union_anchor: false, // 是否是主播
    is_recharge_limit: false, // 谷歌苹果充值金额是否达到限制
    has_salary_wallet: false, // 是否展示薪资钱包
  },
  walletDiamond: {
    overage: 0,
    total_diamond: 0,
    room_diamond: 0,
    out_diamond: 0,
    product_list: [],
    is_exchange: true,
    current_level: 0, // 当前等级
    current_level_salary: 0, // 当前等级最高兑换薪资
    exchanged_salary: 0, // 已兑换薪资
    enable_exchange_salary: 0, // 可兑换薪资
    official_reward_coin: 0, // 官方奖励金币
    official_reward_salary: 0, // 官方奖励薪资
    official_reward_is_open: false, // 官方奖励是否开启
  },
}

// 是否是游戏白名单
export async function is_whitelist_user() {
  const res = await http.post('live/game/is_whitelist_user', {
    ...window.store.getState().env.deviceinfo,
  })
  return res.data
}

// 查询是否满足首冲条件
export async function is_hit_first_recharge() {
  const res = await http.post('live/misc/is_hit_first_recharge', {
    ...window.store.getState().env.deviceinfo,
  })
  return res.data.data
}
// 查询是否满足复购
export async function repurchase_pop_up() {
  const res = await http.post('live/misc/repurchase_pop_up', {
    ...window.store.getState().env.deviceinfo,
  })
  return res.data.data
}

export enum recharge_type_enum {
  正常第三方支付 = 0,
  币商充值 = 1,
}
// [创建订单前的校验信息] http://wiki.xunlei.cn/pages/viewpage.action?pageId=127566187
export async function info_before_create_order(params: {
  product_id: string
  recharge_type: recharge_type_enum
}) {
  const res = await http.post<
    // 0不需要任何弹窗，不阻断 1仅弹窗提示，不阻断充值  2弹窗提示，且阻断充值
    HiyaRes<{err_msg: string; msg: string; status: 0 | 1 | 2}>
  >('/live/pay/info_before_create_order', {
    ...window.store.getState().env.deviceinfo,
    ...params,
  })
  return res.data.data
}

// 获取币商列表
export const get_recharge_agency_list = createAsyncThunk(
  'hiyaWallet2/get_recharge_agency_list',
  async (params: any, store: any) => {
    const resp = await http.post('/live/pay/get_recharge_agency_list', {
      ...store.getState().env.deviceinfo,
      limit: 1000,
      offset: 0,
      country_code: -1,
      ...params,
    })
    return resp.data
  }
)

export const createRechargeOrderV2 = createAsyncThunk(
  'hiyaWallet2/createRechargeOrderV2',
  async (
    params: {
      product_id: string
      pay_method_id: number
      from: string
      code: number
      source: string
      from_page: string
      room_id: number
    },
    store: any
  ) => {
    const resp = await http.post(
      '/live/pay/create_order_h5_v2',
      {
        ...store.getState().env.deviceinfo,
        mid: store.getState().env.deviceinfo.h_m,
        ...params,
      },
      {
        xcHideLog: true,
        xcErrorToast: true,
      }
    )
    return resp.data
  }
)

// 获取充值商品信息
export const getProductsList = createAsyncThunk(
  'hiyaWallet2/getProductsList',
  async (param: any = {}, store: any) => {
    const resp = await http.post('/live/pay/get_products_list', {
      ...store.getState().env.deviceinfo,
      ...param,
      before_recharged: 1,
    })
    return resp.data
  }
)
// [web通过mid获取用户信息] http://wiki.xunlei.cn/pages/viewpage.action?pageId=96438988
export const simpleMemberByMid = createAsyncThunk(
  'hiyaWallet2/simpleMemberByMid',
  async (arg, store: any) => {
    // 待完善 http的返回类型
    const resp = await http.post('/live/account/simple_member_by_mid', {
      ...store.getState().env.deviceinfo,
      mid: store.getState().env.deviceinfo.h_m,
    })
    return resp.data.data
  }
)
// 【钱包 钻石信息】http://wiki.xunlei.cn/pages/viewpage.action?pageId=138980690
export const getWalletDiamond = createAsyncThunk(
  'hiyaWallet2/walletDiamond',
  async (arg, store: any) => {
    const resp = await http.post(
      '/live/settle/wallet',
      store.getState().env.deviceinfo
    )
    return resp.data
  }
)

export const HabiWalletSlice = createSlice({
  name: 'HabiWallet',
  initialState,
  reducers: {
    // 设置当前所在的页面是钻石 还是金币
    setCurTab: (state, action: PayloadAction<number>) => {
      Object.assign(state, {
        ...state,
        curTab: action.payload,
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getProductsList.fulfilled, (state, action) => {
      const {data = {}} = action.payload
      // 防止已经保存的数据被完全清除
      Object.assign(state.wallet, {...data})
    })
    builder.addCase(simpleMemberByMid.fulfilled, (state, action) => {
      Object.assign(state.wallet, {
        baseInfo: action.payload,
      })
    })
    builder.addCase(getWalletDiamond.fulfilled, (state, action) => {
      const {data = {}} = action.payload
      Object.assign(state.walletDiamond, {...data})
    })
    builder.addCase(get_recharge_agency_list.fulfilled, (state, action) => {
      const {data} = action.payload
      Object.assign(state.coinsAgency, {...data?.list})
    })
  },
})
export default HabiWalletSlice.reducer
export const HabiWalletActions = HabiWalletSlice.actions
